<template lang='pug'>
  v-container(fill-height)
    v-row
      v-col(align='center')
        h1.text-h4.blue-grey--text.text--darken-1 Would you like to try Bionic Metrics?
        h1.text-subtitle-1.blue-grey--text.text--darken-2
          | Send us a note at&nbsp;
          a(href='mailto:hello@bionicmetrics.com') hello@bionicmetrics.com
          | &nbsp;to setup a demo and trial account.

</template>

<script>
import _ from 'lodash';
import {mapGetters, mapActions} from 'vuex';
import External from '../api/external';
import Notifications from '../services/notification.service';

export default {
  name: 'SignUp',
  async mounted() {
    await this.getPlanPro();
    await this.getPlanEssentials();
  },
  computed: {
    _() {
      return _;
    },
    ...mapGetters({
      planPro: 'getPlanPro',
      planEssentials: 'getPlanEssentials'
    })
  },
  methods: {
    async createAccount() {
      if (this.user && this.user.password !== this.user.confirmPassword) {
        return Notifications.alert('Passwords do not match');
      }
      if (this.user.password.length < 8) {
        return Notifications.alert('Password must be at least 8 characters long');
      }

      this.disableButton = true;

      try {
        //Credit card component doesn't throw
        this.user.stripeToken = await this.$refs.creditcard.submit();
        if (!this.user.stripeToken) throw new Error('INVALID_PAYMENT');

        if (!this.selectedPlan) throw new Error('INVALID_PLAN');
        this.user.planId = this.selectedPlan.id;

        await External.signup(this.user);
        return this.$router.push('/confirm');
      } catch (e) {
        this.error(e);
      } finally {
        this.enable();
      }
      return 'screw you eslint';
    },
    updatePlanSelection(plan) {
      this.selectedPlan = plan;
      this.$refs.planDialog.hide();
    },
    enable() {
      this.disableButton = false;
    },
    error(err) {
      console.warn('An exception occurred:');
      console.warn(err);
      this.enable();
      if (_.get(err, 'response.data.message') === 'EMAIL_TAKEN') {
        Notifications.alert(`${this.user.email} is already taken, please choose a different email.`);
      } else if (err.message === 'INVALID_PAYMENT') {
        Notifications.alert('Invalid Payment Information');
      } else if (err.message === 'INVALID_PLAN') {
        Notifications.alert('You Must Select a Plan');
      }
      return err;
    },
    ...mapActions({
      getPlanPro: 'getPlanPro',
      getPlanEssentials: 'getPlanEssentials'
    })
  },
  data() {
    return {
      emailTakenContent: 'Email Taken',
      disableButton: false,
      hidePassword: true,
      selectedPlan: null,
      user: {
        planId: null,
        firstName: null,
        lastName: null,
        email: null,
        username: null,
        password: null,
        confirmPassword: null
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .other-links {
    margin-top: 50px;
  }

  #front-links a {
    color: #546E7A;
  }

  #front-links a:link {
    text-decoration: none;
  }

  #front-links a:visited {
    text-decoration: none;
  }

  #front-links a:hover {
    color: #546E7A;
    text-decoration: underline;
  }

  #front-links a:active {
    color: #546E7A;
    text-decoration: underline;
  }
</style>
